__turbopack_context__.v({
  "avatarWrapper": "styles-module__QIc-PG__avatarWrapper",
  "bottomLeftPicture": "styles-module__QIc-PG__bottomLeftPicture",
  "container": "styles-module__QIc-PG__container",
  "feedbackContainer": "styles-module__QIc-PG__feedbackContainer",
  "picturePanels": "styles-module__QIc-PG__picturePanels",
  "reviewCount": "styles-module__QIc-PG__reviewCount",
  "rightPicture": "styles-module__QIc-PG__rightPicture",
  "shopInfo": "styles-module__QIc-PG__shopInfo",
  "shopName": "styles-module__QIc-PG__shopName",
  "topLeftPicture": "styles-module__QIc-PG__topLeftPicture",
});
